import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from '../services/api.service';

@Injectable({
    providedIn: 'root'
})
export class isAuthorizedGuard implements CanActivate, CanActivateChild {
	constructor(private apiService: ApiService,
				private router: Router) {}

    canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> { 

		if(this.apiService.decodedToken?.isGod)
			return true;

		if(this.apiService.isAuthenticated) {

			const routing = state.url.slice(1).split("/").reduce((acc, item) => [...acc, `${acc.last ?? ''}/${item}`], []);

			return this.apiService.get("menu", {shared: true}).pipe(
				map(menu => menu.flatDeep(item => item.children).filter(({link, canActivate}) => routing.includes(link) && canActivate).length > 0),
				map(isAuthorized => {

					if(!isAuthorized)
						this.router.navigate(['/fail/403']);
	
					return isAuthorized;
				}),
				catchError(() => {
					this.router.navigate(['/fail/403']);
					return of(false);
				})
			);
			
		} else
			return false;
	}

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> { return this.canActivate(route, state); }
}